import { Field, Form } from "@kanda-libs/ks-component-ts";
import { Button } from "@kanda-libs/ks-design-library";
import type { FunctionComponent } from "react";
import useAddReferredBy from "./useAddReferredBy";

const AddReferredBy: FunctionComponent = function () {
  const { form, editing, onClick, onSubmit, isSubmitting } = useAddReferredBy();
  return (
    <Form id="staff-add-referred-by" form={form} onSubmit={onSubmit}>
      {!editing && <div onClick={onClick}>None - Click to add</div>}
      {editing && (
        <div className="flex flex-row items-center">
          <Field.Input label="Referred by" name="referredBy" />
          <Button.Text
            submit
            id="staff-referred-by"
            label="Save"
            isLoading={isSubmitting}
          />
        </div>
      )}
    </Form>
  );
};

export default AddReferredBy;
